import { combineReducers } from 'redux';
import authReducer from './authReducer';
import globalAlertReducer from './globalAlertReducer';
import modalReducer from './modalReducer';

export default combineReducers({
  authData: authReducer,
  globalAlertData: globalAlertReducer,
  modalData: modalReducer
});